import React from "react";
import {
  Box,
  Paper,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useTranslation } from "react-i18next";

const FilterSearch = ({ value, onChange, onClear, onKeyDown }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: 339,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Paper
        sx={{
          display: "flex",
          alignItems: "center",
          width: 330,
          height: 42,
          pl: 1.5,
          pr: 1.5,
          bgcolor: "background.default",
          borderRadius: 1,
          border: "1px solid #2E404D",
        }}
      >
        <SearchIcon
          sx={{
            width: 20,
            height: 20,
            mr: 1,
            color: "#2E404D",
          }}
        />

        <TextField
          fullWidth
          variant="standard"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={t("dataModels.searchby")}
          InputProps={{
            disableUnderline: true,
            sx: {
              height: 42,
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
            },
            endAdornment: value && (
              <InputAdornment position="end">
                <IconButton
                  onClick={onClear}
                  edge="end"
                  size="small"
                  sx={{ color: "#2E404D", padding: 0 }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Paper>
    </Box>
  );
};

export default FilterSearch;
